import React from 'react';
import styled from 'styled-components';

import { ReactComponent as SettingsIcon } from '@src/assets/escher/icons/settings.svg';
import { ReactComponent as Logo } from '@src/assets/logo-enigma.svg';

import UserDropdown from './UserDropdown';

export default function Header() {
  return (
    <StyledHeader>
      <a href='/console' rel='noopener noreferrer'>
        <StyledLogo />
      </a>
      <RightSide>
        <UserDropdown />
        <a href='/lists'><SettingsIcon /></a>
      </RightSide>
    </StyledHeader>
  );
}

const StyledHeader = styled.header`
  height: 46px;
  margin-bottom: 40px;
  position: relative;
  width: 100%;
  @media ${props => props.theme.device.landscape} {
    padding-top: 20px;
  }
`;

const RightSide = styled.div`
  float: right;

  a {
    padding: 10px;
  }
`;

const StyledLogo = styled(Logo)`
  width: 116px;
  height: 100%;
`;
